import { FC } from 'react'
import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { ProductPage } from '~/components/ProductPage/WardrobeProductPage'
import { WardrobeProductConfigurator } from '~/components/ProductPage/productTypes/wardrobe'
import { OpeningType } from '~/components/ThreeDModel/furnitureConfig'

export const preview = {
  name: 'products.wardrobe.1.name',
  link: '/product/wardrobe/2',
  // src: '/wardrobe/Beige/maner/Base 60/H2100/right/1600-3.png',
  src: '/cdn/ready-products/wardrobe/1600-3_2.png',
  dimensions: '150x210x50',
  color: 'Beige',
  price: 8530,
}

const Product: FC = () => {
  return (
    <ProductPageLayout>
      <ProductPage
        components={WardrobeProductConfigurator}
        name={preview.name}
        values={{
          imageCarousel: [
            // '/wardrobe/Beige/maner/Base 60/H2100/right/1600-3.png',
            '/cdn/ready-products/wardrobe/1600-3_2.png',
          ],
          colors: preview.color,
          dimensions: {
            width: 150,
            height: 210,
            depth: 50,
            plintHeight: 5,
          },
          furniture: {
            openingType: OpeningType.RoundHandle,
            guides: 'homepage.configurator.fittings.guides.options.1',
          },
          sections: {
            number: 2,
            mirror: 'nu',
            arrangement: [
              {
                src: '/cdn/wardrobe/filling/Beige/2100/1.png',
                width: 100,
                height: 210,
              },
              {
                src: '/cdn/wardrobe/filling/Beige/2100/1.png',
                width: 50,
                height: 210,
              },
            ],
            opening: [
              {
                src: '/cdn/wardrobe/opening-double.png',
                width: 100,
                height: 224,
              },
              {
                src: '/cdn/wardrobe/opening-right.png',
                width: 50,
                height: 224,
              },
            ],
          },
          price: preview.price,
        }}
      />
    </ProductPageLayout>
  )
}

export default Product
